import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  bundleActivity: {
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
    h4: {
      fontWeight: 400,
      color: theme.palette.neutralSecondary,
    },
  },
  activityContent: {
    background: 'transparent',
    boxShadow: 'none',
  },
  activityShowing: {
    fontWeight: 400,
    fontSize: pxToRem(12),
    color: theme.palette.neutralSecondary,
    selectors: {
      '& span': {
        fontWeight: 600,
      },
    },
  },
  showMoreActivityButton: {
    float: 'right',
    selectors: {
      '&:hover': {
        color: theme.palette.themePrimary,
        textDecoration: 'none',
      },
    },
  },
  showMoreActivity: {
    fontSize: pxToRem(14),
    cursor: 'pointer',
    marginTop: pxToRem(14),
    color: theme.palette.themePrimary,
  },
  description: {
    wordBreak: 'break-all',
  },
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  cancelButton: {
    marginRight: pxToRem(16),
    fontWeight: 400,
  },
});
